
export enum CustomFieldScope {
    TASK        = 1,
    PROJECT     = 2,
    USER        = 3,
    CUSTOM      = 100
}

export enum CustomFieldAccess {
    EVERYONE            = 1,                // voobche vse... gd.const.companyRole.CLIENT,
    MANAGERS_ONLY       = 4,                // oups... eto full access project gd.const.companyRole.MANAGER
}

// export function customFieldAccessLabel(access:CustomFieldAccess) {
//
//     switch (access) {
//         case CustomFieldAccess.MANAGERS_ONLY:
//             return "Organization managers"
//
//         case CustomFieldAccess.EVERYONE:
//             return "Everyone"
//         default:
//             return "Unknown Access #error 32032893jkd"
//     }
// }



export const CustomFieldAccessOptions : Option[] = [
    {
        value   : CustomFieldAccess.MANAGERS_ONLY,
        label   : "Organization managers"
    },
    {
        label: "Everyone",
        value: CustomFieldAccess.EVERYONE
    }
];